// Import React and useState hook
import React, { useState } from 'react';

// Import Speed Dial and Speed Dial Action from Material UI
import { SpeedDial, SpeedDialAction } from '@mui/material';

// Import Stylesheet
import classes from '../TVCardReactions/Reactions.module.css';

// Import custom viewport hook
import { useViewport } from '../../../../CustomHooks/useViewport';

// Import global stylesheet for Speed Dial styling
import '../TVCardReactions/TVCardReactions.global.css';

// Import helper function to round off numbers
import numberRoundOff from '../../../../HelperFunctions/numberRoundOff';

// Import reaction icons
import { ReactComponent as ReactionIcon } from '../../../../Assets/Images/ReactionImages/ReactionBadge.svg';
import { ReactComponent as InspiringIcon } from '../../../../Assets/Images/ReactionImages/Inspiring.svg';
import { ReactComponent as EcoImpactIcon } from '../../../../Assets/Images/ReactionImages/EcoImpact.svg';
import { ReactComponent as SocialImpactIcon } from '../../../../Assets/Images/ReactionImages/SocialImpact.svg';

// Import API utility for making requests
import API from '../../../../Axios/axios';

import { useNavigate } from 'react-router-dom';

// Import redux hooks for state management
import { useDispatch } from 'react-redux';
import { reactionUpdate } from '../../../../Store/TVPagePostsSlice';

// Import component for sign-in modal
import GoToSignInModal from '../../../CommonComponents/GoToSignInModal/GoToSignInModal';
import { singlePageReactionUpdate } from '../../../../Store/singlePostSlice';
import MyToolTip from '../../../CommonComponents/MyToolTip';

// React component for reactions
const Reactions = ({ postData, postType, isShorts }) => {
  // Destructure postData props
  const {
    id,
    reaction_score: { reaction_type, inspiring_score, eco_score, social_score },
  } = postData;

  const breakPoint = 900;
  const token = localStorage.getItem('token');
  const { width } = useViewport();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Initialize state variables
  const [open, setOpen] = useState(false);
  const [goToSignInModal, setGoToSignInModal] = useState(false);

  // Function to handle opening the speed dial
  const handleOpen = () => setOpen(true);

  // Function to handle closing the speed dial
  const handleClose = () => setOpen(false);

  // Function to handle click on reaction icons
  const ReactionIconClickHandler = async (type) => {
    if (token) {
      try {
        const response = await API.post(
          `/posts/${id}/reactions`,
          {},
          {
            headers: { Authorization: `token ${token}` },
            params: { type: type },
          }
        );
        if (response.data.message) {
          if (postType === 'single') {
            dispatch(singlePageReactionUpdate(response.data));
          } else {
            dispatch(reactionUpdate(response.data));
          }
        }
      } catch (e) {
        if (e.response.data.message === 'Invalid token.') {
          localStorage.removeItem('token');
          navigate('/entry/signin');
        }
        setOpen(false);
      }
    } else {
      setGoToSignInModal(true);
    }
    setOpen(false);
  };

  // Function to get the appropriate reaction icon based on the reaction type
  const getReactionIcon = () => {
    return <InspiringIcon className={['ins', 'ei', 'si'].includes(reaction_type) ? classes.reactionActive : ''} style={{ height: '3rem', width: '3rem' }} />;

  };

  const getTotalReactions = () => {
    const total = eco_score + social_score + inspiring_score;
    if (total === 0) {
      return '';
    }
    return total;
  }

  return (
    <>
      {goToSignInModal && (
        <GoToSignInModal setGoToSignInModal={setGoToSignInModal} />
      )}
      <MyToolTip title="Inspiring" placement="top">
        <div className={`${classes.reaction} ${isShorts ? classes.shortReactionHolder : classes.reactionHolder}`}>
          <InspiringIcon
            onClick={() => ReactionIconClickHandler('ins')}
            className={`${classes.icon} ${isShorts ? classes.forShorts : classes.forTvCard}  ${['ins', 'ei', 'si'].includes(reaction_type) ? classes.reactionActive : ''}`} />
          <span className={isShorts ? classes.shortsCount : classes.tvCardCount}>{getTotalReactions()}</span>
        </div>
      </MyToolTip>
    </>
  );
};

export default Reactions;
